import React from 'react';
function ChairmanMessage() {
  return (
    <section className="chairman" id="chairman">
      <div className="wrap reveal">
        <div className="chairman-inner">
          <div className="chairman-photo">
            <img
              className=""
              src="/image/CM.JPG"
              alt="Comprehensive High School"
            />
          </div>
          <div className="chairman-text">
            <div className="eyebrow">{"Chairman's Message"}</div>
            <span className="chairman-quote-mark">{'“'}</span>
            <p className="msg">
              The world has become a fiercely competitive arena. For Pakistan,
              to enter into and win the race for economic and political
              selfsufficiency, it is imperative that our youth be developed into
              welleducated, perfectly groomed administrators capable of
              competing and winning in any environment, all the while
              maintaining their individual & national character. We strongly
              believe that we can play a major role in producing such
              individuals.
            </p>
            <p className="msg">
              We welcome you as a new student at CHS and we believe that at the
              completion of your study you will be transformed into a thoroughly
              competent professional, capable of handling the most challenging
              of careers. Most of all, we would like you to become a responsible
              & caring human being leading your country to a glorious future.
              Let the sky be the limit in your personal growth & development. We
              strive to achieve the career goals that you have set for yourself.
            </p>
            <p className="msg"> Wishing you the best in life!</p>
            <div className="chairman-sign">
              <div className="who">
                <b className="script">{'Mr. Mahmood Tufail'}</b>
                <span>{'M.A. (Eng), M.Ed.'}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default ChairmanMessage;
